import QlikWebSocketManager, {
    retryOperation,
} from 'websockets/manager/QlikWebSocketManager';
import { saasRequest } from 'websockets/utils/SaaSUtils';
import { fetchApp } from 'components/qvrf_component/qApp';
import { loadCss, loadScript } from 'utils';
const enigma = require('enigma.js/enigma');

const qApp = async (config) => {
    return new Promise(async (resolve, reject) => {
        try {
            await loadCss(config.tenantUri);
            await loadScript(config.tenantUri);
        } catch (err) {
            console.log('css failed to load', err);
        }

        config.prefix = '/';

        const baseUrl =
            (config.secure ? '' : 'http://') +
            config.host +
            (config.port ? ':' + config.port : '') +
            config.prefix +
            'resources';

        window.require.config({
            baseUrl,
            webIntegrationId: config.webIntegrationId,
        });

        const app = await fetchApp(config, config.prefix);

        resolve(app);
    });
};

class QlikSaaSManager extends QlikWebSocketManager {
    async initSocket(config) {
        this.config = config;
        const schema = await (
            await fetch(
                'https://unpkg.com/enigma.js@2.7.0/schemas/12.612.0.json'
            )
        ).json();

        const url = await this._getSocketUrl(config.appId);
        const session = enigma.create({ url, schema });
        this.globalInterface = await session.open();
        this.qAppPromise = await this.setupQApp().catch((error) => {
            console.error('Failed to open application', error);
        });
        this.qDocPromise = await this.globalInterface
            .openDoc(config.appId)
            .catch((error) => {
                console.error('Failed to open document', error);
            });
        this.qDoc = this.qDocPromise;
    }

    async setupQApp() {
        return await retryOperation(
            async () => await qApp(this.config),
            500,
            5
        );
    }

    async getCsrfToken() {
        const { tenantUri, webIntegrationId } = this.config;

        try {
            const res = await saasRequest(
                tenantUri,
                '/api/v1/csrf-token',
                webIntegrationId,
                false
            );
            return res.headers.get('qlik-csrf-token');
        } catch (err) {
            console.error('failed to fetch CSRF token', err);
        }
    }

    async _getSocketUrl(appId) {
        const { tenantUri, webIntegrationId } = this.config;
        const csrfToken = await this.getCsrfToken();
        return `${tenantUri.replace(
            'https',
            'wss'
        )}/app/${appId}?qlik-web-integration-id=${webIntegrationId}&qlik-csrf-token=${csrfToken}`;
    }

    async getSheets() {
        const qOptionsSheet = {
            qOptions: {
                qTypes: ['sheet'],
                qIncludeSessionObjects: true,
                qData: {},
            },
        };
        return await this.qDoc.getObjects(qOptionsSheet);
    }

    async getSheet(sheetId) {
        return this.qDoc.getObject(sheetId);
    }

    async getLayout(sheet) {
        return sheet.getAppLayout();
    }
}

export default QlikSaaSManager;
